export const cortaString = (texto, longitud, sinPuntos) => {
  if (!texto) return;
  if (texto.length > longitud) {
    return texto.slice(0, longitud) + (sinPuntos !== true ? "..." : "");
  }

  return texto;
};
